/** Заготовка списка, пока переписки грузятся: те же размеры, что у настоящей строки. */
export function ListSkeleton({ rows = 8 }: { rows?: number }) {
  return (
    <div role="status" aria-label="Загрузка переписок" className="py-1">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-2.5">
          <div className="sk size-13 rounded-full" />
          <div className="flex-1 flex flex-col gap-2">
            <div className="sk h-4 w-2/5" />
            <div className="sk h-3.5 w-4/5" />
          </div>
        </div>
      ))}
    </div>
  );
}
